// extracted by mini-css-extract-plugin
module.exports = {"AwardsItems":"AwardsItems_AwardsItems__14zbT"};